import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-gray-900 text-gray-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-display font-bold text-white flex items-center gap-2">
              💰 Paise Ki Pathshala
            </h3>
            <p className="mt-3 text-sm">{t('tagline')}</p>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-3">Quick Links</h4>
            <div className="flex flex-col gap-2 text-sm">
              <Link to="/learn" className="hover:text-brand-400">{t('nav.learn')}</Link>
              <Link to="/tips" className="hover:text-brand-400">{t('nav.tips')}</Link>
              <Link to="/stories" className="hover:text-brand-400">{t('nav.stories')}</Link>
              <Link to="/contact" className="hover:text-brand-400">{t('nav.contact')}</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-3">Contact</h4>
            <p className="text-sm">Kallcy Global India Pvt. Ltd</p>
            <p className="text-sm mt-1">info@paisekipathshala.com</p>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-sm">
          © {new Date().getFullYear()} Paise Ki Pathshala. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
